module.exports = __webpack_public_path__ + "img/surimo@2x.3640d38.png";